<template>
    <div class="blog-details-area ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="blog-details-desc">
                        <div class="article-image">
                            <img src="../../assets/images/blog/preventive-dentistry/mouth-guards-main-page.webp" alt="image">

                        </div>

                        <div class="article-content">
                            <div class="row">
                                

                                <h2><u>{{ $t('blog_page_preventive_dentistry_apnea_what_title') }}</u></h2>
                                <p>{{ $t('blog_page_preventive_dentistry_apnea_what_p') }}</p>
                                <h2><u>{{ $t('blog_page_preventive_dentistry_apnea_reasoning_title') }}</u></h2>
                                <p>{{ $t('blog_page_preventive_dentistry_apnea_reasoning_p') }}</p>
                                
                            </div>
                            <div class="row">
                                <div class="services-details-content">

                                    <u><h2>{{ $t('blog_page_preventive_dentistry_apnea_symptoms_title') }}</h2></u>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6">
                                            <ul>
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li1') }}
                                                </li>
                    
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li2') }}
                                                </li>
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li3') }}
                                                </li>
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li4') }}
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-lg-6 col-md-6">
                                            <ul>
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li5') }}
                                                </li>
                
                                            
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li6') }}
                                                </li>
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li7') }}
                                                </li>

                                                
                                                <li>
                                                    {{ $t('blog_page_preventive_dentistry_apnea_symptoms_li8') }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <h2><u>{{ $t('blog_page_preventive_dentistry_apnea_dealing_title') }}</u></h2>
                                    <p>{{ $t('blog_page_preventive_dentistry_apnea_dealing_p1') }}</p>
                                    <p>{{ $t('blog_page_preventive_dentistry_apnea_dealing_p2') }}</p>
                                </div>
                            </div>

                            <div class="article-tag">
                                <span>Share:</span>
                                <a href="https://www.facebook.com/" target="_blank"><i class='bx bxl-facebook'></i></a>
                                <a href="https://twitter.com/?lang=en" target="_blank"><i class='bx bxl-twitter'></i></a>
                                <a href="https://www.linkedin.com/" target="_blank"><i class='bx bxl-linkedin'></i></a>
                                <a href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
                            </div>
                        </div>

                        
                    </div>
                </div>

                
                
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PreventiveSportsSplints',
    
    
}
</script>

